"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function treeify(data) {
    var tree = { size: 0 };
    for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
        var _a = data_1[_i], path = _a[0], size = _a[1];
        var parts = path.replace(/\/$/, '').split('/');
        var t = tree;
        var _loop_1 = function () {
            var id = parts.shift();
            if (!t.children)
                t.children = [];
            var child = t.children.find(function (c) { return c.id === id; });
            if (!child) {
                child = { id: id, size: 0 };
                t.children.push(child);
            }
            if (parts.length === 0) {
                if (child.size !== 0) {
                    throw new Error("duplicate path " + path + " " + child.size);
                }
                child.size = size;
            }
            t = child;
        };
        while (parts.length > 0) {
            _loop_1();
        }
    }
    return tree;
}
exports.treeify = treeify;
function flatten(n, join) {
    if (join === void 0) { join = function (parent, child) { return parent + "/" + child; }; }
    if (n.children) {
        for (var _i = 0, _a = n.children; _i < _a.length; _i++) {
            var c = _a[_i];
            flatten(c, join);
        }
        if (n.children.length === 1) {
            var child = n.children[0];
            n.id += '/' + child.id;
            n.children = child.children;
        }
    }
}
exports.flatten = flatten;
function rollup(n) {
    if (!n.children)
        return;
    var total = 0;
    for (var _i = 0, _a = n.children; _i < _a.length; _i++) {
        var c = _a[_i];
        rollup(c);
        total += c.size;
    }
    if (total > n.size)
        n.size = total;
}
exports.rollup = rollup;
function sort(n) {
    if (!n.children)
        return;
    for (var _i = 0, _a = n.children; _i < _a.length; _i++) {
        var c = _a[_i];
        sort(c);
    }
    n.children.sort(function (a, b) { return b.size - a.size; });
}
exports.sort = sort;
//# sourceMappingURL=tree.js.map